import React, { Component,useState } from 'react';
import Header from '../../containers/Header';
import Footer from '../../containers/Footer';
import {useHistory} from 'react-router-dom';

const Cart = () =>{
  let history = useHistory();

    return (
      <div>
        <Header/>

        <Footer/>
      </div>
        );
  }

export default Cart;